import { render, staticRenderFns } from "./comp_MegaMenuHorizontalItem.vue?vue&type=template&id=57acf336&scoped=true"
import script from "./comp_MegaMenuHorizontalItem.vue?vue&type=script&lang=js"
export * from "./comp_MegaMenuHorizontalItem.vue?vue&type=script&lang=js"
import style0 from "./comp_MegaMenuHorizontalItem.vue?vue&type=style&index=0&id=57acf336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57acf336",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VListItemTitle})
